'use client';

import { useContext } from 'react';
import CardPushBlock from '../blocks/CardPushBlock';
import { BlockColumnHeight } from '../types';
import { CommonDataContext } from 'app/provider/CommonDataProvider';
import mapBlockColumnsToCardInfo from '@/lib/mappers/mapBlockColumnsToCardInfo';
import { FfbbsiteBlockColumns, FfbbsiteBlockColumnsRows } from '@/lib/directus';

export default function PushNews() {
  const {
    global: { data: globalData },
  } = useContext(CommonDataContext)!;

  let pushNews = false;
  let blockPushData = null;
  let blockPushHeight = 'default' as BlockColumnHeight;
  if (globalData?.push_news) {
    const blockColumn = globalData?.push_news as FfbbsiteBlockColumns;
    blockPushHeight = (blockColumn.height || 'default') as BlockColumnHeight;
    const blockColumnsRows = blockColumn.rows as FfbbsiteBlockColumnsRows[];
    blockPushData = mapBlockColumnsToCardInfo(blockColumnsRows);
    if (blockPushData?.cards?.length > 0) {
      pushNews = true;
    }
  }

  if (!pushNews || !blockPushData?.cards || !Array.isArray(blockPushData.cards)) {
    return null;
  }

  return (
    <div className="w-full py-2">
      <CardPushBlock cards={blockPushData.cards} height={blockPushHeight} />
    </div>
  );
}
